module.exports = __webpack_public_path__ + "SocialCropped-6790782835df1c76f70ddfdf4f9fa093.png";